<template>
    <SideNav ref="sidenav" always-show-back class="change-password">
        <div class="header">
            <div class="corner">
                <div class="corner-inner">
                    <div class="back" @click="comeback()"></div>
                    <div class="title"> Смена пароля пользователя</div>
                </div>
            </div>

            <div class="adhoc">
                <div class="adhoc-wrapper">
                    <div class="adhoc-content">
                        <div class="close" @click="comeback"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="middle">
            <div v-if="message" class="message error">{{ message }}</div>

            <div class="form-field">
                <div class="title">Текущий пароль</div>
                <div class="value">
                    <password v-model="v.currentPassword.$model"
                              :a-class="{ error: v.currentPassword.$error }"
                              class="current-password"
                              placeholder="Введите текущий пароль"
                              type="current-password" />
                    <TooltipOld :opened="!!currentPasswordError"
                                bind-to=".current-password"
                                class="error tooltip"
                                trigger-on="focus">
                        {{ currentPasswordError }}
                    </TooltipOld>
                </div>
            </div>

            <div class="form-field">
                <div class="title">Придумайте пароль</div>
                <div class="value">
                    <password v-model="v.password.$model"
                              :a-class="{ error: v.password.$error }"
                              class="new-password"
                              placeholder="Введите новый пароль"
                              type="new-password" />
                    <TooltipOld :opened="!!passwordError"
                                bind-to=".new-password input"
                                class="error tooltip"
                                trigger-on="focus">
                        {{ passwordError }}
                    </TooltipOld>
                    <TooltipOld :opened="!passwordError"
                                bind-to=".new-password input"
                                class="inform password" trigger-on="focus">
                        <SafetyPassword :password="password" />
                    </TooltipOld>
                </div>
            </div>

            <div class="form-field">
                <div class="title">Повторите пароль</div>
                <div class="value">
                    <password v-model="v.password2.$model"
                              :a-class="{ error: v.password2.$error }"
                              class="repeat-password"
                              placeholder="Введите пароль повторно"
                              type="repeat-password" />
                    <TooltipOld :opened="!!passwordConfirmError"
                                bind-to=".repeat-password"
                                class="error tooltip"
                                trigger-on="focus">
                        {{ passwordConfirmError }}
                    </TooltipOld>
                </div>
            </div>
        </div>

        <div class="footer">
            <input class="ghost"
                   type="button"
                   value="Отмена"
                   @click="comeback()" />
            <input :disabled="v.$invalid"
                   class="primary"
                   type="button"
                   value="Сменить"
                   @click="save()" />
        </div>
    </SideNav>
</template>

<script>
import { currentUser } from '@/common/session.js';
import { entropy } from '@/common/validators.js';
import { passwordChange } from '@/restapi/user/user.js';
import { showNotice } from '@dsee/components/popups/toast.js';
import { useVuelidate } from '@vuelidate/core';
import { minLength, required, sameAs } from '@vuelidate/validators';
import SafetyPwdMixin from '@/common/comp/safety_password/safety.pwd.mixin.js';
import SafetyPassword from '@/common/comp/safety_password/SafetyPassword.vue';


export default {
    mixins: [ SafetyPwdMixin ],
    components: {
        SafetyPassword,
    },
    setup() {
        return {
            v: useVuelidate({ $stopPropagation: true }),
        };
    },
    data() {
        return {
            currentPassword: '',
            password: '',
            password2: '',
            message: '',
        };
    },
    computed: {
        userEmail() {
            return currentUser()?.email;
        },
        passwordError() {
            if (!this.v.password.$dirty) return null;

            if (this.v.password.required.$invalid)
                return 'Не указан пароль';

            return null;
        },
        currentPasswordError() {
            if (!this.v.currentPassword.$dirty) return null;

            if (this.v.currentPassword.required.$invalid)
                return 'Не указан пароль';

            return null;
        },
        passwordConfirmError() {
            if (!this.v.password2.$dirty) return null;

            if (this.v.password2.required.$invalid)
                return 'Подтвердите пароль';

            if (this.v.password2.sameAs.$invalid)
                return 'Пароли не совпадают';

            return null;
        },
    },
    validations() {
        return {
            currentPassword: {
                required,
            },
            password: {
                required,
                minLength: minLength(8),
                entropy: entropy(24),
            },
            password2: {
                required,
                sameAs: sameAs(this.password),
            },
        };
    },
    methods: {
        open() {
            this.reset();
            this.$refs.sidenav.open();
        },
        close() {
            this.$refs.sidenav.accept();
        },
        comeback() {
            this.close();
            this.$emit('comeback');
        },
        reset() {
            this.currentPassword = '';
            this.password = '';
            this.password2 = '';
            this.message = '';
            this.v.$reset();
        },
        async save() {
            this.v.$touch();

            if (this.v.$invalid) return;

            try {
                await passwordChange({
                    password: this.currentPassword,
                    newPassword: this.password,
                });
                this.close();
                showNotice('Пароль успешно сменён');
            } catch (e) {
                this.message = e.message;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/common/comp/safety_password/safety.pwd.scss';

.change-password {
    .header {
        .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
        }
    }

    .message.error {
        color: #ff0c0c;
    }
}
</style>
